import { Record } from "immutable"

const UserRecord = new Record({
  id: null,
  email: null,
  token: null,

  created: null,
  updated: null,
  lastLogin: null,

  verified: null,

  firstname: null,
  lastname: null,

  apiToken: null,
  affiliateId: null,

  cardDiscount: null,
  balanceDiscount: null,
  balances: null,
})

export default class User extends UserRecord {
  getBalance(currency) {
    const balance = this.balances.find(bal => bal.currency.toLowerCase() === currency.toLowerCase())

    return balance ? balance.amount : 0
  }

  hasBalanceInOtherCurrency(currency) {
    const balanceInOtherCurrency =
      this.balances &&
      this.balances.find(
        bal => bal.currency.toLowerCase() !== currency.toLowerCase() && bal.amount > 0,
      )
    return !!balanceInOtherCurrency
  }
}
